import { render, staticRenderFns } from "./PreQuestion5.vue?vue&type=template&id=0d90f662&scoped=true&"
import script from "./PreQuestion5.vue?vue&type=script&lang=js&"
export * from "./PreQuestion5.vue?vue&type=script&lang=js&"
import style0 from "./PreQuestion5.vue?vue&type=style&index=0&id=0d90f662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d90f662",
  null
  
)

export default component.exports